import { Button, Modal } from '@scuf/common';
import React from 'react';
import { useTranslation } from 'react-i18next';
type Props = {
    open: boolean;
    onclose: VoidFunction;
    noteNumber: string;
    onconfirm: VoidFunction;
};
const DeleteInvoiceModal: React.FC<Props> = ({ open, onclose, onconfirm }: Props) => {
    const { t } = useTranslation(['spareparts', 'common']);
    return (
        <Modal open={open} closeIcon={true} onClose={onclose} size="small">
            <p>{t('translation.DeleteInvoiceConfirmation')}</p>
            <div>
                <Button type="secondary" size="small" content={t('common:actions.Cancel')} onClick={onclose}></Button>
                <Button
                    size="small"
                    content={t('common:actions.Yes')}
                    onClick={() => {
                        onclose();
                        onconfirm();
                    }}
                ></Button>
            </div>
        </Modal>
    );
};

export default DeleteInvoiceModal;
